// extracted by mini-css-extract-plugin
module.exports = {"SearchInput":"styles_SearchInput__twfLm","content":"styles_content__100T_"};